
import { faArchive, faArrowRotateLeft, faArrowsUpDownLeftRight, faEdit, faFlagCheckered, faPaperPlane, faPlay, faPlus, faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./ButtonAction.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { faBuffer, faBuromobelexperte, faInstalod } from "@fortawesome/free-brands-svg-icons";

function ButtonAction({ typeBtn, border, textBtn, onClick, loading }) {


    /*
    type:
     add - Добавить
     work - В работу
     edit - Изменить
     remove - Удалить
     save - Сохранить
     finish - Завершить
     archive - Архивировать
     cancel - Отмена
     send - Отправить
     widget - Widget
     moving - Перемещение


     border: Рамка вокругкнопки
      border_dg - Красная
    */
    const stateSize = useSelector((state) => state.size);//Размеры окна

    const [text, setText] = useState(null);
    const [icon, setIcon] = useState(null);

    useEffect(() => {
        if (typeBtn === 'add') {
            setIcon(faPlus);

            if (textBtn === undefined) {
                setText('Добавить');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'work') {
            setIcon(faPlay);

            if (textBtn === undefined) {
                setText('В работу');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'edit') {
            setIcon(faEdit);

            if (textBtn === undefined) {
                setText('Изменить');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'remove') {
            setIcon(faTrash);

            if (textBtn === undefined) {
                setText('Удалить');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'save') {
            setIcon(faSave);

            if (textBtn === undefined) {
                setText('Сохранить');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'finish') {
            setIcon(faFlagCheckered);

            if (textBtn === undefined) {
                setText('Завершить');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'archive') {
            setIcon(faArchive);

            if (textBtn === undefined) {
                setText('Архивировать');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'cancel') {
            setIcon(faArrowRotateLeft);

            if (textBtn === undefined) {
                setText('Отмена');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'send') {
            setIcon(faPaperPlane);

            if (textBtn === undefined) {
                setText('Отправить');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'widget') {
            setIcon(faBuromobelexperte);

            if (textBtn === undefined) {
                setText('Widget');
            }
            else {
                setText(textBtn);
            }
        }
        if (typeBtn === 'moving') {
            setIcon(faArrowsUpDownLeftRight);

            if (textBtn === undefined) {
                setText('Перемещение');
            }
            else {
                setText(textBtn);
            }
        }
    }, []);


    return (
        <>
            {icon !== null && (
                stateSize.desktop === true ?
                    (
                        <button className={border === undefined ? 'button_action' : 'button_action ' + border} onClick={onClick} disabled={loading}>
                            <i className="mr-5"><FontAwesomeIcon icon={icon} /></i>
                            {text}
                        </button>
                    )
                    :
                    (
                        <button className='m_button_action' onClick={onClick} disabled={loading}>
                            <div className="m_button_action_icon"><i><FontAwesomeIcon icon={icon} /></i></div>
                            <div className="m_button_action_text">{text}</div>
                        </button>
                    )
            )}
        </>
    )
}

export default ButtonAction;